import { Analytics } from "@vercel/analytics/react";

/**
 * Vercel Web Analytics is cookieless (per-visit anonymous hash).
 * First-party event tracking (`trackEvent`) stays behind cookie consent.
 * Preview and local hosts are excluded so only lucentiasocial.com is measured.
 */
export function ConsentAwareAnalytics() {
  return <Analytics mode="production" />;
}
